import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';
import { Button, Icon, SmallLoader } from 'learning-panel-components';
import { translate } from 'translations';
import SelectPrimaryCourseContainer from '@components/accountSettings/primaryCourse/selectPrimaryCourseContainer';
import { showAlert } from '@redux/slices/informationSlice';
import styles from './primaryCourseDialog.module.scss';

const PrimaryCourseDialog: FC<{
    setIsPrimaryCourseDialogOpen: Function;
}> = ({ setIsPrimaryCourseDialogOpen }) => {
    const dispatch = useDispatch();
    const [showSuccessNotification, setShowSuccessNotification] = useState<boolean>(false);
    const [notificationMessage, setNotificationMessage] = useState<string>('');
    const [submitEnabled, setSubmitEnabled] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [primaryCourseUuid, setPrimaryCourseUuid] = useState<string>('');

    useEffect(() => {
        if (showSuccessNotification) {
            dispatch(
                showAlert({
                    value: notificationMessage,
                    status: 'success'
                })
            );

            setSubmitEnabled(false);
            setIsPrimaryCourseDialogOpen(false);
        }
    }, [dispatch, notificationMessage, setIsPrimaryCourseDialogOpen, showSuccessNotification]);

    useEffect(() => {
        if (primaryCourseUuid) setSubmitEnabled(true);
    }, [primaryCourseUuid]);

    const onSubmit = () => {
        setIsSubmitting(true);
        setSubmitEnabled(false);
    };

    const onError = () => {
        setIsSubmitting(false);
        setSubmitEnabled(true);
    };

    return (
        <div className={styles['background-wrapper']}>
            <div
                className={classnames(styles['primary-course-wrapper'])}
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/accountSettings.svg)` }}
            >
                {isLoading && <SmallLoader size="85px" className={styles.loader} />}
                <div className={classnames(styles['primary-course-content'], isLoading ? styles.loading : '')}>
                    <Icon name="primaryCourse" isPng className={styles.icon} />
                    <div className={styles.title}>
                        <div>{translate('selectPrimaryCourse')}</div>
                    </div>
                    <div className={styles['item-wrapper']}>
                        <SelectPrimaryCourseContainer
                            setShowSuccessNotification={setShowSuccessNotification}
                            setNotificationMessage={setNotificationMessage}
                            shouldSubmitChange={isSubmitting}
                            onLoad={() => setIsLoading(false)}
                            onSelect={(uuid: string) => setPrimaryCourseUuid(uuid)}
                            onError={onError}
                        />
                    </div>
                    <div className={styles.submit}>
                        <Button
                            type={submitEnabled ? 'bigGradient' : 'bigGradientDisable'}
                            onClick={onSubmit}
                            text={translate('setAndContinue')}
                            lowerCase
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrimaryCourseDialog;
